const anchorParrents = document.querySelectorAll('.menu-item');
const anchorStatic = document.querySelector('.menu-item-49 a');
const header = document.querySelector('header');

let menuBtn = document.querySelector('.burger');
let menu = document.querySelector('.mobile__menu');
let disableScroll = document.querySelector('body');

window.addEventListener('DOMContentLoaded', () => {
  anchorParrents.forEach(function(anchorParrent) {
    const anchorLinks = anchorParrent.querySelectorAll('.menu-item a');

    anchorLinks.forEach(function(item){
      item.addEventListener('click', function(e){
        if(e.target === anchorStatic) {
          console.log('click')
        } if (e.target !== anchorStatic) {
          let clickValue = e.target.getAttribute('href');

          if(!document.body.classList.contains('home')) {
            window.location.href = window.location.origin + clickValue;

            menu.classList.remove('active');
            menuBtn.classList.remove('active');
            disableScroll.classList.remove('body-scroll');

            window.scrollTo({
              top: document.getElementById(`${clickValue.replace('#', '')}`).offsetTop - (header.clientHeight * 1.5),
              behavior: 'smooth'
            })
          }

          if(document.body.classList.contains('home')) {
            if([...clickValue][0] == '#') {
              e.preventDefault();

              menu.classList.remove('active');
              menuBtn.classList.remove('active');
              disableScroll.classList.remove('body-scroll');


              window.scrollTo({
                top: document.getElementById(`${clickValue.replace('#', '')}`).offsetTop - (header.clientHeight * 1.5),
                behavior: 'smooth'
              })
            }
          }
        }
      });
    })
  });
})









// const anchorParrents = document.querySelectorAll('.menu-item');
// const header = document.querySelector('header');

// let menuBtn = document.querySelector('.burger');
// let menu = document.querySelector('.mobile__menu');
// let disableScroll = document.querySelector('body');

// window.addEventListener('DOMContentLoaded', () => {
//   anchorParrents.forEach(function(anchorParrent) {
//     const anchorLinks = anchorParrent.querySelectorAll('.menu-item a');

//     anchorLinks.forEach(function(item, index){
//       if (index === 0) return;

//       item.addEventListener('click', function(e){
//         let clickValue = e.target.getAttribute('href');

//         if(!document.body.classList.contains('home')) {
//           window.location.href = window.location.origin + clickValue;

//           menu.classList.remove('active');
//           menuBtn.classList.remove('active');
//           disableScroll.classList.remove('body-scroll');

//           window.scrollTo({
//             top: document.getElementById(`${clickValue.replace('#', '')}`).offsetTop - (header.clientHeight * 1.5),
//             behavior: 'smooth'
//           })
//         }

//         if(document.body.classList.contains('home')) {
//           if([...clickValue][1] == '#') {
//             e.preventDefault();

//             menu.classList.remove('active');
//             menuBtn.classList.remove('active');
//             disableScroll.classList.remove('body-scroll');


//             window.scrollTo({
//               top: document.getElementById(`${clickValue.replace('#', '')}`).offsetTop - (header.clientHeight * 1.5),
//               behavior: 'smooth'
//             })
//           }
//         }
//       });
//     })
//   });
// })






